import { render, staticRenderFns } from "./ValidGeral.vue?vue&type=template&id=cdf54df2&"
import script from "./ValidGeral.vue?vue&type=script&lang=js&"
export * from "./ValidGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports